/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
import "emoji-mart/css/emoji-mart.css";
import "react-markdown-editor-lite/lib/index.css";

import {
  Avatar,
  Card,
  Col,
  List,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";

const SavedMessages = () => {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
  const supabase = getSupaClient();
  const [savedMessages, setSavedMessages] = useState([]);
  const [threadMessages, setThreadMessages] = useState([]);

  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [previewMessage, setPreviewMessage] = useState({});

  const teamId = localStorage.getItem("team-id");

  const loadThreadMessage = async (parentId) => {
    const { data, error } = await supabase
      .from("floppy_thread_msgs")
      .select(
        `slack_id, 
        key:slack_id, 
        text, 
        slack_user(name, slack_id, image_32),
        reaction_count,
        formatted_ts`
      )
      .filter("team", "eq", teamId)
      .filter("parent_msg", "eq", parentId)
      .order("formatted_ts", { ascending: false });
    if (error) console.log("error", error);
    if (data) {
      console.log("thread data", data);
      setThreadMessages(data);
    }
  };

  const loadSavedMessages = async () => {
    const { data, error } = await supabase
      .from("floppy_parent_msgs")
      .select(
        `slack_id, 
        key:slack_id, 
        team, 
        channel (name), 
        slack_user(name, slack_id, image_32),
        reply_count, 
        text, 
        formatted_ts, 
        permalink`
      )
      .filter("team", "eq", teamId)
      .order("formatted_ts", { ascending: false });
    if (error) console.log("error", error);
    if (data) {
      setSavedMessages(data);
    }
  };

  const loadPageData = async () => {
    await loadSavedMessages();
    setLoading(false);
  };

  useEffect(() => {
    loadPageData();
  }, []);

  const showPreview = async (parentId) => {
    await loadThreadMessage(parentId);
    setPreviewVisible(true);
  };

  const clearPreview = () => {
    setPreviewMessage({});
    setPreviewVisible(false);
  };

  const savedMessageColumns = [
    {
      title: "Posted",
      dataIndex: "formatted_ts",
      render: (text, record) =>
        dayjs(record.formatted_ts).format("DD-MMM, HH:mm"),
      sorter: (a, b) => {
        // console.log(a, b, dayjs(a.tweet.created_at).unix());
        return dayjs(a.formatted_ts).unix() - dayjs(b.formatted_ts).unix();
      },
      width: "10%",
    },
    {
      title: "Message",
      dataIndex: "text",
      key: "text",
      render: (text, record) => (
        <div>
          <Row>
            <Col span={2}>
              <Avatar src={record.slack_user?.image_32} />
            </Col>
            <Col span={22}>
              <Row>
                <span style={{ color: "grey", marginRight: "10px" }}>
                  {record.slack_user.name}
                </span>
                <Tooltip title="Click to open in slack">
                  <a href={record.permalink} target="_blank" rel="noreferrer">
                    <img
                      alt="Link"
                      width="16"
                      className="pt-0.5"
                      src="/external-link.svg"
                    />
                  </a>
                </Tooltip>
              </Row>
              <Row>
                <a onClick={() => showPreview(record.slack_id)}>
                  {record.text}
                </a>
              </Row>
            </Col>
          </Row>
        </div>
      ),
      // ...getMessageSearchProps("text"),
      width: "60%",
    },
    {
      title: "Channel",
      dataIndex: "channel.name",
      render: (text, record) => <div>{record.channel.name}</div>,
      width: "20%",
    },
  ];

  return (
    <div>
      <p>
        {savedMessages.length > 0
          ? "You can connect Notion, Airtable or Coda to directly store these messages as well!"
          : "No messages saved. You can store it by clicking an individual message in slack and click Save threads"}
      </p>
      <Row justify="spaced-around" gutter={[32, 32]}>
        <Col lg={24} md={24}>
          <Card bordered={false}>
            <div style={{ width: "100%", height: "100%" }}>
              <Table dataSource={savedMessages} columns={savedMessageColumns} />
            </div>
          </Card>
        </Col>
      </Row>
      <Modal visible={isPreviewVisible} onCancel={clearPreview} footer={null}>
        <p>{threadMessages.length ? "Responses" : "No responses"}</p>
        <List
          size="small"
          bordered
          dataSource={threadMessages}
          renderItem={(item) => (
            <List.Item>
              <div className="flex flex-row">
                <div className="mr-5">
                  <Avatar src={item.slack_user?.image_32} />
                </div>
                <div>
                  <span style={{ color: "grey", marginRight: "10px" }}>
                    {item.slack_user.name}
                  </span>
                  <div>{item.text}</div>
                </div>
              </div>
            </List.Item>
          )}
        />
      </Modal>
    </div>
  );
};

export default SavedMessages;
